import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { PasswordStateBoxControl } from "@/Myle/EntryPoints/MyleApp/Login/PasswordBoxControl";

import styles from "./LoginCredentialsView.module.scss";

export interface ILoginCredentialsViewProps {
    userName: string;
    validatingCredentials: boolean;
    isLoggedIn: boolean;
    stringProvider: ResourceProvider;
    errorMessageJsx: JSX.Element;
    buttonTextLabelKey: string;
    linkTextLabelKey: string;
    href?: string;

    onSubmit: () => void;
    onUsernameChange: (username: string) => void;
    onPasswordChange: (password: string) => void;
    onLinkClick?: () => void;
}

export function LoginCredentialsView(props: ILoginCredentialsViewProps): JSX.Element {
    const { errorMessageJsx } = props;

    const { getText } = useTranslation(props.stringProvider);

    const keyCodeOffset: number = Math.floor(Math.random() * 35) + 15;

    function handleKeyPress(e: React.KeyboardEvent): void {
        if (!props.validatingCredentials && e.key === "Enter")
            enterKeyPress();
    }

    function enterKeyPress(): void {
        props.onSubmit();
    }

    return (
        <>
            <div>
                <label className={styles.labelStyle} htmlFor="user_name">
                    {getText("username")}
                </label>
                <input
                    type="text"
                    id="user_name"
                    data-cy="login-username"
                    disabled={props.validatingCredentials}
                    className={`form-control ${styles.input}`}
                    placeholder={getText("UsernamePlaceholder")}
                    onKeyUp={e => handleKeyPress(e)}
                    onChange={e => props.onUsernameChange(e.target.value)}
                    value={props.userName}
                />
            </div>
            {!props.validatingCredentials && !props.isLoggedIn && (
                <div className={`${styles.pwdMarginBottom}`}>
                    <label className={styles.labelStyle} htmlFor="password">
                        {getText("password")}
                    </label>
                    <PasswordStateBoxControl
                        id="password"
                        dataCy="login-password"
                        className={`form-control ${styles.input}`}
                        placeholder={getText("PasswordPlaceholder")}
                        capsLockOnMessage={getText("CapsLockOn")}
                        onChange={value => props.onPasswordChange(value)}
                        keyOffset={keyCodeOffset}
                        onEnterPress={() => enterKeyPress()}
                    />
                </div>
            )}

            <div className={styles.marginBottom}>{errorMessageJsx}</div>

            <div className={styles.marginBottom}>
                <button
                    disabled={props.validatingCredentials || props.isLoggedIn}
                    className="btn btn-primary submit"
                    id="loginButton"
                    data-cy="login-button"
                    onClick={() => props.onSubmit()}
                    type="button"
                >
                    {getText(props.buttonTextLabelKey)}
                </button>
            </div>
            <div className={styles.textAlign}>
                <a href={props.href} onClick={() => props.onLinkClick()}>
                    {getText(props.linkTextLabelKey)}
                </a>
            </div>
        </>
    );
}
